import attachmentSchema from './attachment.schema';
import { validationMessages } from './validationMessages.schema';

export default {
  type: 'object',
  properties: {
    attachments: {
      title: 'Załączniki wniosku',
      type: 'array',
      items: attachmentSchema,
      warnings: {
        minItems: 1,
        warningMessages: {
          minItems:
            'Dołącz załącznik, a jeśli nie chcesz dołączyć załącznika zmień wybór w części wniosku „Czy chcesz dodać załącznik”.'
        }
      },
      minItems: 1,
      validationMessages: {
        minItems: 'Załącznik nie został dołączony.'
      }
    }
  },
  allOf: [validationMessages]
};
